import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../../ui/sheet';
import ProjectGenerationLauncher from '../ProjectGenerationLauncher';

/** V15.21 — Modes secondaires (batch multi-lots, caméra FPS) dans un tiroir : hors du parcours principal. */
export const BatchAndFpsDrawer = ({ open, mode, onClose, projectId, onJobLaunched }) => (
  <Sheet open={open} onOpenChange={(v) => { if (!v) onClose?.(); }}>
    <SheetContent side="right" className="w-[920px] max-w-[95vw] overflow-y-auto" style={{ background: 'var(--c-surface-0)', border: '1px solid var(--c-border)', color: 'var(--c-text)' }} data-testid="batch-fps-drawer">
      <SheetHeader>
        <SheetTitle className="text-[15px]">{mode === 'fps' ? 'Caméra FPS — vue à hauteur d\'œil' : 'Génération en batch — plusieurs lots'}</SheetTitle>
        <SheetDescription className="text-[11.5px]" style={{ color: 'var(--c-text-2)' }}>
          {mode === 'fps' ? 'Placez la caméra sur le plan puis lancez : le rendu rejoint l\'historique du lot.' : 'Ouvrez « Avancé » puis cochez « Multi-lot » pour sélectionner les lots à lancer en une fois.'}
        </SheetDescription>
      </SheetHeader>
      <div className="mt-4">
        <ProjectGenerationLauncher key={mode} projectId={projectId} onJobLaunched={onJobLaunched} initialMode={mode === 'fps' ? 'fps' : 'shoebox'} initialAdvanced={mode === 'batch'} />
      </div>
    </SheetContent>
  </Sheet>
);

export default BatchAndFpsDrawer;
